import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_SUBCONTRACTOR} from '../../constants';

export default {
  id: 'SUPP_FOURN',
  title: 'Come posso rimuovere un fornitore?',
  description: '',
  categories: [CONTENT_CATEGORY_SUBCONTRACTOR],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'È possibile rimuovere un fornitore una volta che la missione è completata e in qualsiasi momento dal tuo abbonamento sulla piattaforma. Avrete naturalmente la possibilità di restituirgli un invito per recuperare le sue attestazioni.'
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '1.',
    value: 'Vai alla scheda «Fornitori»'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_SUPP_FOURN/IT_SUPP_FOURN_1.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '2.',
    value: 'Sulla linea del fornitore che si desidera rimuovere, fare clic sui tre punti a destra'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_SUPP_FOURN/IT_SUPP_FOURN_2.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '3.',
    value: 'Quindi fare clic su «Cancellare dal mio elenco»'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_SUPP_FOURN/IT_SUPP_FOURN_3.png`
  }]
};
